(function () {
    'use strict';

    /*
     * NC LIVE — sous-copie contextuelle des cartes du menu mobile.
     * Issu du test NC_PRAGERU_MENU_13 (variante gagnante, promue en live).
     *
     * Posé pour TOUS les visiteurs, au chargement de la page, avant toute ouverture du menu.
     * Aucun appel à Shoplift.
     */

    /*
     * Le menu d'origine répétait « High-quality premium collections » sur les trois cartes ;
     * la version live donne à chacune sa phrase. La carte est reconnue par son lien : un titre
     * se réécrit dans l'éditeur de thème, une destination beaucoup moins.
     */
    var SOUS_COPIES = [
        ['/products/celebrate-america-race-to-the-white-house-board-game', 'Fun for the Whole Family'],
        ['/collections/books', 'Educational & Patriotic'],
        ['/collections/clothing', 'Premium & Supports the Mission']
    ];

    var CARTE = '.mob-menu-cards__card';
    var SOUS_TITRE = '.mob-menu-cards__subtitle';

    function pose() {
        var cartes = document.querySelectorAll(CARTE);
        for (var i = 0; i < cartes.length; i++) {
            var lien = cartes[i].getAttribute('href') || '';
            var ligne = cartes[i].querySelector(SOUS_TITRE);
            if (!ligne) continue;

            for (var j = 0; j < SOUS_COPIES.length; j++) {
                if (lien.indexOf(SOUS_COPIES[j][0]) !== -1) ligne.textContent = SOUS_COPIES[j][1];
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pose);
    } else {
        pose();
    }
})();
